// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__66wXS","colMin":"styles_colMin__1-60r","colCheckbox":"styles_colCheckbox__3h7oA"};